import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons8-excel-48.png'


const _withScopeId = n => (_pushScopeId("data-v-320f8386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm ecran-container-oferta" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","align-items":"center","gap":"1rem","cursor":"pointer"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_9 = { style: {"color":"black","font-weight":"bold","margin-bottom":"8px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 2,
  style: {"display":"flex","justify-content":"flex-end","padding-bottom":"1rem"}
}
const _hoisted_12 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_13 = { style: {"color":"black","font-weight":"bold","margin-bottom":"8px"} }
const _hoisted_14 = { class: "q-px-md" }
const _hoisted_15 = {
  class: "produs_img",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"2px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white" }, " Cannot load image ", -1))
const _hoisted_18 = { class: "produs_detalii" }
const _hoisted_19 = { class: "app__property--medium" }
const _hoisted_20 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }
const _hoisted_28 = { key: 7 }
const _hoisted_29 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","font-style":"italic"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "app__property--medium" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 1,
  class: "shopping_cart__container--btns"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 0,
  class: "app-center-content-horizontal"
}
const _hoisted_40 = {
  key: 1,
  class: "app-center-content-horizontal"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"36px","height":"36px"},
  src: _imports_0
}, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_43 = {
  key: 3,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_44 = {
  key: 4,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 100px)","top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrowseCategories = _resolveComponent("BrowseCategories")!
  const _component_BrowseArticles = _resolveComponent("BrowseArticles")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_EditQuantityArticleCerere = _resolveComponent("EditQuantityArticleCerere")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_NomEditAdresaLivrare = _resolveComponent("NomEditAdresaLivrare")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBrowseArticles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.pidForBrowseCategoryHasArticles)
            ? (_openBlock(), _createBlock(_component_BrowseCategories, {
                key: 0,
                pid: _ctx.pidForBrowseCategory,
                typeOfAccess: 'fromCerere'
              }, null, 8, ["pid"]))
            : _createCommentVNode("", true),
          (_ctx.pidForBrowseCategoryHasArticles)
            ? (_openBlock(), _createBlock(_component_BrowseArticles, {
                key: 1,
                pidCategory: _ctx.pidForBrowseCategory,
                typeOfAccess: 'fromCerere',
                productPid: _ctx.productPid,
                code: _ctx.code
              }, null, 8, ["pidCategory", "productPid", "code"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.fromBackOffice && _ctx.userStore.user.tip != '3')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  icon: "event_repeat",
                  label: _ctx.$t('message.repeat_request'),
                  "no-caps": "",
                  onClick: _ctx.repetaCerere,
                  style: {"margin-top":"1rem","background-color":"#9b7d32","color":"white"}
                }, null, 8, ["label", "onClick"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'div_card_mobile' : 'div_card_desktop')
          }, [
            _createVNode(_component_q_input, {
              outlined: "",
              disable: _ctx.fromBackOffice || _ctx.userStore.user.tip == '2',
              modelValue: _ctx.nrComandaCerere,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nrComandaCerere) = $event)),
              label: _ctx.$t('message.request_no'),
              counter: "",
              maxlength: "20",
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width: 200px;')
            }, null, 8, ["disable", "modelValue", "label", "style"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_select, {
                outlined: "",
                disable: _ctx.fromBackOffice || _ctx.userStore.user.tip == '2',
                label: _ctx.$t('message.delivery_address'),
                modelValue: _ctx.slidAdresaLivrare,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slidAdresaLivrare) = $event)),
                "option-value": "slid",
                "option-label": "adresaAdresa",
                options: _ctx.adrese,
                "emit-value": "",
                "map-options": "",
                "options-selected-class": "text-deep-orange",
                style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
              }, {
                option: _withCtx((scope) => [
                  _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, {
                            caption: scope.opt.isNewAddress == '1'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.opt.adresaLocalitate), 1)
                            ]),
                            _: 2
                          }, 1032, ["caption"]),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.opt.adresaAdresa), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["disable", "label", "modelValue", "options", "style"]),
              (!_ctx.dialogAdresa && _ctx.changedItemsInOffer)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    square: "",
                    icon: "add",
                    style: {"height":"1rem","width":"1rem","margin-left":"4px","margin-top":"8px","background-color":"#9b7d32","color":"white"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenFormAddNewAdresa()))
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _hoisted_7,
          (_ctx.inputFreeTextComments.length>0 || _ctx.changedItemsInOffer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('message.remarks')) + ":", 1),
                _createVNode(_component_q_input, {
                  disable: _ctx.fromBackOffice || _ctx.userStore.user.tip == '2',
                  maxlength: "250",
                  type: "textarea",
                  autogrow: "",
                  counter: "",
                  class: "input--desire",
                  outlined: "",
                  modelValue: _ctx.inputFreeTextComments,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                  placeholder: _ctx.$t('message.new_request_details'),
                  dense: "",
                  color: "blue-grey-7"
                }, null, 8, ["disable", "modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_10,
          (_ctx.changedItemsInOffer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_q_btn, {
                  style: {"background-color":"#9b7d32","color":"white"},
                  label: _ctx.$t('message.request_new_offer'),
                  "no-caps": "",
                  onClick: _ctx.trySendCerereForAnOffer
                }, null, 8, ["label", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.changedItemsInOffer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('message.status')) + ": " + _toDisplayString(_ctx.humanStatusOffer(_ctx.offerHeader.status)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.appid,
                class: "produs_div"
              }, [
                (item.appid==_ctx.appidToBeTogglesWithFavorites)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      indeterminate: "",
                      color: "secondary",
                      style: {"position":"absolute"}
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.changedItemsInOffer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          icon: "arrow_drop_up",
                          onClick: ($event: any) => (_ctx.moveUP(index))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(index+1), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          icon: "arrow_drop_down",
                          onClick: ($event: any) => (_ctx.moveDown(index))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_img, {
                    transition: "fade",
                    src: _ctx.urlToJPG+'/'+item.categoryPid,
                    ratio: "1",
                    fit: "scale-down",
                    "spinner-color": "light-blue",
                    class: "rounded-borders shopping_cart--img shadow-1"
                  }, {
                    error: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 2
                  }, 1032, ["src"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$i18n.locale == 'de' ? item.productNameDe : _ctx.$i18n.locale == 'ro' ? item.productNameRo : _ctx.$i18n.locale == 'en' ? item.productNameEn : item.productNameHu), 1),
                  _createElementVNode("span", _hoisted_20, [
                    (item.l)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(item.l) + " " + _toDisplayString(item.um1 == 'M' ? 'M ' : 'mm '), 1))
                      : _createCommentVNode("", true),
                    (item.w)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('message.width')) + " " + _toDisplayString(item.w) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.t)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('message.thickness')) + " " + _toDisplayString(item.t) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.d)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('message.diameter')) + " " + _toDisplayString(item.d) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.h)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('message.height')) + " " + _toDisplayString(item.h) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.a)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('message.aliaj')) + " " + _toDisplayString(item.a) + "  ", 1))
                      : _createCommentVNode("", true),
                    (item.k)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('message.eyes')) + " " + _toDisplayString(item.k) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.e)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('message.eyes')) + " 2 " + _toDisplayString(item.e) + " mm ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  (item.observatii)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('message.remarks')) + ": " + _toDisplayString(item.observatii), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (_ctx.changedItemsInOffer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(_component_q_btn, {
                            icon: "edit",
                            label: _ctx.$t('message.modify_quantity'),
                            outline: "",
                            color: "green",
                            "no-caps": "",
                            size: "sm",
                            style: {"margin-right":"1em"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_popup_proxy, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_banner, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_EditQuantityArticleCerere, {
                                        item: item,
                                        index: index,
                                        onEditItem: _ctx.onEditItem
                                      }, null, 8, ["item", "index", "onEditItem"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createElementBlock("br", _hoisted_31))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createElementBlock("br", _hoisted_32))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_btn, {
                            icon: "delete_forever",
                            label: _ctx.$t('message.delete_item_request'),
                            outline: "",
                            color: "red",
                            "no-caps": "",
                            size: "sm",
                            onClick: ($event: any) => (_ctx.removeArticle(item,index))
                          }, null, 8, ["label", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (item.tip_um == 'um12' || item.tip_um == 'um1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.qUm1) + " " + _toDisplayString(item.um1), 1))
                    : _createCommentVNode("", true),
                  (item.um2 && item.um2.length>0 && item.qUm2>0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(item.qUm2) + " KG", 1))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.fromBackOffice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        dense: "",
                        "no-caps": "",
                        style: {"max-width":"12rem","margin-left":"1rem","background-color":"#9b7d32","color":"white"},
                        onClick: ($event: any) => (_ctx.toggleArticleInFavorites(item,index))
                      }, {
                        default: _withCtx(() => [
                          (item.isInFavorite)
                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                key: 0,
                                left: "",
                                size: "1.3rem",
                                name: "favorite",
                                color: "red"
                              }))
                            : (_openBlock(), _createBlock(_component_q_icon, {
                                key: 1,
                                left: "",
                                size: "1.2rem",
                                name: "favorite_border",
                                color: "red"
                              })),
                          _createVNode(_component_q_tooltip, {
                            anchor: "top middle",
                            self: "bottom middle",
                            offset: [10, 10],
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              (item.isInFavorite)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('message.item_in_favorite_remove')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('message.add_to_favorite')), 1))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.changedItemsInOffer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_q_btn, {
                    icon: "add_shopping_cart",
                    label: _ctx.$t('message.add_item_request'),
                    outline: "",
                    color: "#273233",
                    "no-caps": "",
                    onClick: _ctx.browseArticle,
                    style: {"margin-top":"1rem"}
                  }, null, 8, ["label", "onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.fromBackOffice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_q_btn, {
                    label: _ctx.$t('message.download'),
                    outline: "",
                    color: "#273233",
                    "no-caps": "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadExcel())),
                    style: {"margin-top":"1rem"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogAdresa,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogAdresa) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { class: "bg-white" }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      icon: "arrow_back",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_42
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 1,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_icon, {
                      key: 2,
                      name: "arrow_back_ios",
                      class: "app__arrow--back"
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_NomEditAdresaLivrare, {
                  propAdresa: _ctx.selectedAdresa,
                  closeHandler: _ctx.closeFormEditAdresaLivrare
                }, null, 8, ["propAdresa", "closeHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}